import React, { Children, useState } from "react";

import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";

// import JS files
import { useUserData } from "../../context/UserDataContext";
import MuiTheme from "./MuiTheme";

// import Others files

const Input = styled("input")({
  display: "none",
});
const UploadButton = styled(Button)({
  color: "#6e6e6e",
  border: "1px solid #bdbdbd",
  "&:hover": {
    backgroundColor: "transparent",
    color: "#1976d2",
  },
  "&:active": {},
  "&:focus": {},
});

const MuiUpload = ({ setImageFile }) => {

  const handlePictureFile = (e) => {
    const file = e.target.files[0];
    if (file.size <= 1000000) {
      setImageFile(file);
    } else {
      toast.error("فایل انتخابی شما باید کم‌تر از یک مگ باشد.", {
        position: toast.POSITION.TOP_CENTER,
      });
      e.target.value = "";
    }
  };

  return (
    <>
      <MuiTheme>
        <label htmlFor="contained-button-file">
          <Input
            accept="image/*"
            id="contained-button-file"
            type="file"
            onChange={(e) => handlePictureFile(e)}
          />
          <UploadButton
            variant="text"
            component="span"
            style={{ display: "flex" }}
          >
            <span>بارگذاری تصویر</span>
          </UploadButton>
        </label>
      </MuiTheme>
    </>
  );
};

export default MuiUpload;
